import { render, staticRenderFns } from "./pointEdit.vue?vue&type=template&id=d548f964&scoped=true&"
import script from "./pointEdit.vue?vue&type=script&lang=ts&"
export * from "./pointEdit.vue?vue&type=script&lang=ts&"
import style0 from "./pointEdit.vue?vue&type=style&index=0&id=d548f964&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d548f964",
  null
  
)

export default component.exports